import styled from "@emotion/styled";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { COLOR_BLACK, COLOR_PRIMARY_MAIN } from "../../theme/colors";

export const StyledFormControlLabel = styled(FormControlLabel)`
  height: 24px;

  &.MuiFormControlLabel-root {
    .MuiFormControlLabel-label {
      font-size: 0.875rem;
      font-weight: 500;
      color: ${COLOR_BLACK};
    }
  }
`;

export const StyledCheckbox = styled(Checkbox)`
  &.Mui-checked {
    color: ${COLOR_PRIMARY_MAIN};
  }
`;
